<template>
  <Transition name="modal-fade">
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 dark:bg-brand-900/60 backdrop-blur-xl"
      @click.self="closeModal"
    >
      <div class="w-full max-w-md rounded-[28px] border bg-white dark:bg-brand-800 border-slate-100 dark:border-brand-700/50 shadow-2xl p-8 sm:p-10">
        
        <div class="text-center mb-6">
          <h1 class="text-3xl font-bold tracking-tight text-slate-900 dark:text-white"><span class="bg-gradient-to-r from-brand-500 to-fuchsia-500 dark:from-purple-400 dark:to-violet-300 bg-clip-text text-transparent">Recuperar senha</span></h1>
          <p class="text-sm text-slate-600 dark:text-slate-400 mt-2">Digite seu e‑mail para receber o código.</p>
        </div>

        <div v-if="feedbackMessage.text" :class="['mb-6 text-center rounded-xl px-4 py-3 text-sm font-medium border',
          feedbackMessage.type === 'success'
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-400/30'
            : 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-400/30']">{{ feedbackMessage.text }}</div>

        <form @submit.prevent="handleForgotPassword" class="space-y-6" novalidate>
          <div>
            <label for="forgot-email" class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">E‑mail de cadastro</label>
            <input id="forgot-email" v-model="email" type="email" required class="w-full rounded-2xl border bg-slate-50/70 dark:bg-brand-900/40 border-slate-200 dark:border-brand-700/50 px-4 py-3 text-sm text-slate-900 dark:text-white placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none transition focus:ring-4 focus:ring-brand-500/20 focus:border-brand-500"/>
          </div>
          <button type="submit" :disabled="isLoading" class="group relative w-full rounded-2xl bg-gradient-to-r from-violet-600 via-fuchsia-600 to-indigo-600 px-5 py-3.5 text-sm font-semibold text-white shadow-[0_12px_40px_-8px_rgba(124,58,237,.55)] transition active:scale-[.99] disabled:opacity-70">
            <span class="relative z-10">{{ isLoading ? 'Enviando…' : 'Enviar código' }}</span>
            <span class="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-white/10"></span>
          </button>
        </form>

        <div class="mt-6 text-center text-sm">
          <a href="#" @click.prevent="switchToLogin" class="font-semibold text-brand-600 hover:text-brand-700 dark:text-brand-400 dark:hover:text-brand-300">Voltar para o login</a>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, watch } from 'vue'
import authService from '@/service/authService'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'switch-view'])

const closeModal = () => {
  emit('close')
}
const switchToLogin = () => {
  emit('switch-view', 'login')
}

const email = ref('')
const isLoading = ref(false)
const feedbackMessage = ref({ text: '', type: '' })

watch(() => props.show, (newVal) => {
  if (newVal) {
    email.value = ''
    isLoading.value = false
    feedbackMessage.value = { text: '', type: '' }
  }
})

const handleForgotPassword = async () => {
  isLoading.value = true
  feedbackMessage.value = { text: '', type: '' }
  try {
    await authService.forgotPassword({ email: email.value })
    feedbackMessage.value = { text: 'Se uma conta existir, um código foi enviado.', type: 'success' }
    setTimeout(() => {
      emit('switch-view', 'resetPassword', { email: email.value })
    }, 1200)
  } catch {
    feedbackMessage.value = { text: 'Ocorreu um erro. Tente novamente.', type: 'error' }
  } finally { isLoading.value = false }
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>